import React, {useRef} from 'react';
import {Button, Modal} from 'react-bootstrap';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAdd} from "@fortawesome/free-solid-svg-icons";
import ApiService from "../api/ApiService";
import {toast} from "react-toastify";

const CozeSpaceModal = ({visible,onClose}) => {
    const api = new ApiService();
    const linkInputRef = useRef(null); // 新增ref用于直接访问链接输入框
    const [isMobile, setIsMobile] = React.useState(false);
    React.useEffect(() => {
        const handleResize = () => {
            // 使用 setTimeout 实现简单的防抖
            const timer = setTimeout(() => {
                setIsMobile(window.innerWidth < 768);
            }, 100);

            return () => clearTimeout(timer);
        };

        handleResize(); // 初始化时调用
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    const submitCozeSpace = async () => {
        const inputLink = linkInputRef.current?.value || ''; // 使用ref直接读取输入框的值
        if (inputLink === '') {
            toast.error('请输入空间地址')
            return
        }
        var result = await api.bindCozeSpace(inputLink);
        if (result?.code !== 200){
            toast.error(result?.msg)
        }else {
            onClose(true)
        }
    };
    return (

        <Modal show={visible} centered onHide={onClose}
               style={{'--bs-modal-margin': '2rem', '--bs-modal-width': '700px'}}>
            <Modal.Header closeButton style={{
                background: 'linear-gradient(90deg,#02C8E3 30%, #963BC8 120%)',
                borderBottomColor: 'transparent'
            }}>
                <span style={{color: '#060606', fontSize: '22px'}}>添加Coze空间</span>
            </Modal.Header>
            <Modal.Body style={{background: '#1E2129'}}>
                <p style={{color: '#4E4E4E'}}><img src={'/images/coze/coze_space_link.svg'} width={'24px'}
                                                   alt={''}/> Coze邀请链接</p>
                <div style={{maxHeight: '300px', overflowY: 'auto', overflowX: 'hidden'}}>
                    <textarea className="form-control"  ref={linkInputRef}
                              placeholder="请粘贴您的Coze空间邀请链接，例如：httpe：//www.coze.cm/"
                              style={{background: '#30333B', borderRadius: '10px',minHeight: '116px', color: '#9a9a9a', opacity: 1}}/>
                </div>
                <p style={{
                    color: '#9a9a9a',
                    background: '#30333B',
                    borderRadius: '10px',
                    padding: '20px',
                    marginTop: '16px'
                }}>
                    <img src={'/images/coze/coze_space_lock.svg'} width={'20px'} alt={''} style={{marginRight: '8px'}}/>
                    请确保邀请链接格式正确且在有效期内
                    <a href={'http://www.baidu.com'} style={{color: '#02C8E3', marginLeft: '8px',}}
                       rel="noopener noreferrer"
                       target="_blank">怎么获取邀请链接？</a>
                </p>
            </Modal.Body>
            <Modal.Footer style={{background: '#1E2129', borderTopColor: '#707070'}}>
                <Button variant="primary" onClick={()=>onClose( false)} style={{
                    border: '1px solid #02C8E3',
                    background: "transparent",
                    padding: '12px 48px',
                    color: '#02C8E3'
                }}>
                    取消
                </Button>
                <Button variant="primary" onClick={()=> {
                    submitCozeSpace()
                }} style={{
                    background: 'linear-gradient(135deg,#02C8E3,#4B1E64 150%)',
                    border: 'none',
                    padding: '12px 48px',
                    color: '#060606'
                }}>
                    <FontAwesomeIcon icon={faAdd} width={'16px'} color={'#060606'} style={{marginRight: '8px'}}/>
                    添加
                </Button>
            </Modal.Footer>
            {/* 全局CSS样式 */}
            <style>{`
                .form-control::placeholder {
                    color: #7D7D7D !important;
                }
            `}</style>
        </Modal>

    );
};

export default CozeSpaceModal;